import update from 'immutability-helper';
import SelfServeBuilderEnum from 'SelfServeBuilder/SelfServeBuilderConstants';
import PopupConstants from 'Popups/PopupConstants';
import SelfServeTooltipTourConstants from './TooltipTourConstants';

const initialState = {
  activeToolboxTip: null,
  isToolboxTipHidden: true,
  isToolboxTourHidden: false,
  tooltipInfo: {
    [SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
    [SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
    [SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
    [SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
    [SelfServeTooltipTourConstants.TOOLBOX_TIPS_LIST_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
    [SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP]: {
      tipOutlineRectangle: null,
      isSeen: false,
    },
  },
};

const ToolboxTooltipTourReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  const isTipsTooltip = state.activeToolboxTip ===
    SelfServeTooltipTourConstants.TOOLBOX_TIPS_LIST_TOOLTIP;

  switch (action.type) {
    case SelfServeBuilderEnum.SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS: {
      const isTooltipTourSeen = window.COOKIE.get('onboarding_tooltip_tour_seen');
      if (isTooltipTourSeen || window.location.hash.substring(1) === 'sample-document') {
        return update(state, {
          isToolboxTourHidden: { $set: true },
        });
      }
      window.COOKIE.set('onboarding_tooltip_tour_seen', 1);
      return update(state, {
        activeToolboxTip: { $set: action.activeToolboxTourTooltip || SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP },
        isToolboxTipHidden: { $set: false },
      });
    }
    case SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_SHOW:
      if (state.activeToolboxTip) {
        return update(state, {
          tooltipInfo: {
            [state.activeToolboxTip]: {
              isSeen: { $set: !isTipsTooltip },
            },
          },
          activeToolboxTip: { $set: action.tooltip },
          isToolboxTipHidden: { $set: false },
        });
      }
      return update(state, {
        activeToolboxTip: { $set: action.tooltip },
        isToolboxTipHidden: { $set: false },
      });
    case SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_HIDE_CURRENT:
    case PopupConstants.CREATE_POPUP:
      if (state.activeToolboxTip) {
        return update(state, {
          isToolboxTipHidden: { $set: true },
          activeToolboxTip: { $set: null },
          tooltipInfo: {
            [state.activeToolboxTip]: {
              isSeen: { $set: !isTipsTooltip },
            },
          },
        });
      }
      return state;
    case SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_HIDE_ALL:
      if (!state.tooltipInfo[SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP].isSeen) {
        return update(state, {
          activeToolboxTip: { $set: SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP },
          isToolboxTipHidden: { $set: false },
          isToolboxTourHidden: { $set: true },
        });
      }
      return update(state, {
        isToolboxTourHidden: { $set: true },
      });
    case SelfServeTooltipTourConstants.TOOLBOX_TOOLTIP_LOCATION_SET:
      return update(state, {
        tooltipInfo: {
          [action.tooltip]: {
            tipOutlineRectangle: { $set: action.tipLocationOutline },
          },
        },
      });
    case SelfServeTooltipTourConstants.TOUR_HIDE:
      return update(state, {
        isToolboxTourHidden: { $set: true },
      });
    default:
      return state;
  }
};

export default ToolboxTooltipTourReducer;



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/ToolboxTooltipTourReducer.jsx